import { useState }   from "react";
import useSWRInfinite from "swr/infinite";

import { getPayoutHistory } from "_services/api/payout";

import Presentation from "./presentation";

const swrKey = "diamond-payouts";

const fetcher = async params => {
	const { pageNo } = params;

	let result = await getPayoutHistory ( {
		pageNo,
		pageSize: 10
	} );

	return result;
};

const component = ( { details } ) => {
	const { data, error, size, setSize } = useSWRInfinite (
		index => {
			return {
				key    : swrKey,
				pageNo : index + 1
			};
		},
		fetcher,
		{
			revalidateFirstPage : false,
			revalidateOnFocus   : false
		}
	);

	const isLoadingInitialData = !data && !error;
	const isEmpty              = data?.[size - 1]?.length === 0;
	const isLoadingMore        = isLoadingInitialData || ( size > 0 && data && typeof data[size - 1] === "undefined" );
	const history              = [].concat.apply ( [], data );

	const [ showCalc, setShowCalc ] = useState ( false );
	const [ openInfo, setOpenInfo ] = useState ( false );

	const fetchMore = () => {
		setSize ( size + 1 );
	};

	return (
		<Presentation
			details     = { details }
			fetchMore   = { fetchMore }
			history     = { history }
			isDepleted  = { isEmpty }
			isLoading   = { isLoadingMore }
			openInfo    = { openInfo }
			setOpenInfo = { setOpenInfo }
			setShowCalc = { setShowCalc }
			showCalc    = { showCalc }
		/>
	);
};

export default component;
